export enum OpportunityType {
  Event = 'event',
  Project = 'project',
  EventSeries = 'event_series',
  EventSeriesSession = 'event_series_session',
}

export enum OpportunityLocationTypeDto {
  Virtual = 'virtual',
  Offline = 'in-person',
}

export type OpportunityOnlineLocationDto = Readonly<{
  type: OpportunityLocationTypeDto.Virtual
  link?: string
}>

export type OpportunityInPersonLocationDto = Readonly<{
  type: OpportunityLocationTypeDto.Offline
  country: string
  city: string
  zipCode: string
  addressLineOne: string
  addressLineTwo?: string
  locationName?: string
  locationDisplayName?: string
  long: number
  lat: number
}>

export type OpportunityLocationDto =
  | OpportunityOnlineLocationDto
  | OpportunityInPersonLocationDto
